module.exports = __webpack_public_path__ + "img/3.10a12542.png";